import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from 'react-tooltip';

import "./ExplanationTooltip.scss";

const ExplanationTooltip = ({ text, place }) => {
  return (
    <div className="explanation-tooltip">
      <ReactTooltip place={place} multiline/>
      <div 
        className="explanation-tooltip__question-mark"
        data-tip={text}
      >
        ?
      </div>
    </div>
  );
};

ExplanationTooltip.propTypes = {
  place: PropTypes.string,
  text: PropTypes.string
}

ExplanationTooltip.defaultProps = {
  place: "top",
  text: ""
}

export default ExplanationTooltip;